import './forexlanding.css'
import BuySellForex from './buysellforex'
import StartScreen from './startscreen'
import WhyChooseUs from './whychooseus'
import ChooseCurrency from './ChooseCurrency'
import CurrencyRate from './currencyRate'
import Testimonial from './testimonial'

function Forex() {
  return (
    <>
      <div style={{backgroundColor:'#321E5D',color:'#ffffff'}}>
          <StartScreen />

          <div style={{margin:'50px'}}>

            <BuySellForex />

            <ChooseCurrency />

            <CurrencyRate />

            <div className='infocard'>
              <div>
                <div style={{fontSize:'32px'}}>20+</div>
                <div>Years of Expereince</div>
              </div>

              <div>
                <div style={{fontSize:'32px'}}>100+</div>
                <div>Happy Customer</div>
              </div>

              <div>
                <div style={{fontSize:'32px'}}>15+</div>
                <div>Choice of Services</div>
              </div>

              <div>
                <div style={{fontSize:'32px'}}>20+</div>
                <div>Professional Guides</div>
              </div>
            </div>



            <Testimonial />
            <WhyChooseUs />

          </div>

        
      </div>
    </>
  )
}

export default Forex
